import DOMPurify from 'dompurify';
import { useMemo } from 'react';

interface RichTextProps {
  html: string;
  className?: string;
}

export function RichText({ html, className }: RichTextProps): JSX.Element {
  const sanitized = useMemo(
    () =>
      DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ['target', 'rel'],
      }),
    [html]
  );

  return (
    <div
      className={`stringline-rich-text prose prose-sm max-w-none text-slate-700 prose-headings:font-semibold prose-headings:text-slate-900 prose-h1:mt-4 prose-h1:mb-2 prose-h1:text-lg prose-h2:mt-3 prose-h2:mb-1 prose-h2:text-base prose-h3:mt-2 prose-h3:mb-1 prose-h3:text-sm prose-p:my-1 prose-a:text-brand-600 ${className ?? ''}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
